import { ModalBodyBase } from "@faire/slate/private/modal/ModalBodyBase";
import React from "react";

type IProps = {
  /**
   * The modal body content
   */
  children?: React.ReactNode;
};

/**
 * Base modal body component.
 */
export const BaseModalBody: React.FC<IProps> = ({ children }) => {
  return <ModalBodyBase>{children}</ModalBodyBase>;
};
